/* eslint-disable import/first */
import React from 'react';
import cartEmpty from './images/emptyCart.svg';
import { FormattedMessage } from 'react-intl';
import css from './index.module.scss';

export default function EmptyCart() {
  return (
    <>
      <div className={css.noItem}>
        <img src={cartEmpty} alt="cart is empty" />
        <h2 className={css.noItemTitle}>
          <FormattedMessage id="cart_noItemTitle" defaultMessage="Your Cart is Empty" />
        </h2>
        <h3 className={css.noItemSubTitle}>
          <FormattedMessage
            id="cart_noItemSubTitle"
            defaultMessage="Please add some items from the menu."
          />
        </h3>
      </div>
    </>
  );
}
